import SlotMapping from './SlotMapping';
import GoToIntentSummary from './GoToIntentSummary';

class GoToIntentTreeNode {
  intent: GoToIntentSummary | null;

  resumeStep: number | null;

  slotMappings: SlotMapping[];

  constructor(
    intent: GoToIntentSummary | null,
    resumeStep: number | null,
    slotMappings: SlotMapping[] = []
  ) {
    this.intent = intent;
    this.resumeStep = resumeStep;
    this.slotMappings = slotMappings;
  }

  get intentId(): number | null {
    return this.intent?.id ?? null;
  }
}

export default GoToIntentTreeNode;
